module.exports = __webpack_public_path__ + "static/media/智能排班白皮书.a405c9cb.jpg";